import { StudyPlanApi, StudyPlanStatusEnum, UpdateStudyPlanInfoDTO } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new StudyPlanApi(getAuthConfiguration());

export const getStudyPlanByProgramIdAndYear = (studyProgramId: string, planYear: number) => {
    return ApiFactory().apiStudyPlanGetStudyPlanByProgramIdAndYearStudyProgramIdPlanYearGet({ studyProgramId, planYear });
}

export const getStudyPlanById = (studyPlanId: string) => {
    return ApiFactory().apiStudyPlanGetStudyPlanByIdStudyPlanIdGet({ studyPlanId });
}

export const getAllStudyPlans = (studyProgramId: string, page: number, pageSize: number) => {
    return ApiFactory().apiStudyPlanGetAllStudyPlansStudyProgramIdGet({ studyProgramId, page, pageSize });
}

export const updateStudyPlanDepartment = (studyPlanId: string, departmentId: string) => {
    return ApiFactory().apiStudyPlanUpdateStudyPlanDepartmentStudyPlanIdDepartmentIdPut({ studyPlanId, departmentId });
}

export const downloadStudyPlan = (studyPlanId: string) => {
    return ApiFactory().apiStudyPlanGenerateReportIdReportGet({ id: studyPlanId });
}

export const downloadExtendedStudyPlan = (studyPlanId: string) => {
    return ApiFactory().apiStudyPlanGenerateExtendedReportIdReportGet({ id: studyPlanId });
}

export const updateStudyPlanStatus = (studyPlanId: string, state: StudyPlanStatusEnum, message: string) => {
    return ApiFactory().apiStudyPlanUpdateStudyPlanStatusPostRaw({updateStudyPlanStatusDTO: { studyPlanId, status: state, message: message }});
}

export const downloadStudyPlanDiff = (studyPlanId: string) => {
    return ApiFactory().apiStudyPlanGenerateStudyPlanDiffReportIdReportGet({ id: studyPlanId });
}

    export const downloadStudyPlanIndicators = (studyPlanId: string) => {
    return ApiFactory().apiStudyPlanGenerateStudyPlanIndicatorsReportIdReportGet({ id: studyPlanId });
}

export const ApproveBulkSubjects = (studyProgramId: string) => {
    return ApiFactory().apiStudyPlanBulkApproveSubjectsProgramIdStatusPost({ programId: studyProgramId });
}

export const updateStudyPlanInfo = (studyPlanId: string, updateStudyPlanInfoDTO: UpdateStudyPlanInfoDTO) => {
    return ApiFactory().apiStudyPlanUpdateStudyPlanInfoStudyPlanIdPut({ studyPlanId, updateStudyPlanInfoDTO });
}
